export function countryFlagUrl(iso2: string) {
  if (!/^[A-Z]{2}$/.test(iso2)) return '';
  return `/data/country-flags/${iso2.toLowerCase()}.webp`;
}
